module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Justice-League.ac9a84f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Justice-League.jpg
// module id = c6FP
// module chunks = 0